import { css } from '@emotion/react'
import {
  DesignToken,
  SpacingToken,
} from '@livechat/design-system-react-components'

const dividerCss = (fullWidth?: boolean) =>
  css`
    border-bottom: 1px solid var(${DesignToken.BorderBasicTertiary});
    margin-block: var(${SpacingToken.Spacing5});

    ${fullWidth &&
    `width: calc(100% + 2 * var(--spacing-7));
      margin-inline: calc(0px - var(--spacing-7));
      `}
  `

interface IDividerProps {
  fullWidth?: boolean
}

const Divider = ({ fullWidth }: IDividerProps) => (
  <div css={dividerCss(fullWidth)} />
)

export default Divider
